import { Collection } from "@datx/core";
import { jsonapi } from "@datx/jsonapi";
import Property from "../models/property";
import LoadStatus from "../models/loadStatus";
import CountDashboardData from "../models/countDashboardData";

export default class DataStore extends jsonapi(Collection) {
  static types = [Property, LoadStatus, CountDashboardData];
}
